import * as Models from '../../../models';
import { ResourcesListBasic } from '../../../models/response';
import { MapperApi2_0 } from '../../../mappers';
import { ChampionshipsEndpoints } from '../../../endpoint';

const getParticipantChampionshipsStatus: () => Promise<
  ResourcesListBasic<Models.ParticipantChampionshipStatus>
> = async () => {
  return ChampionshipsEndpoints.getParticipantChampionshipsStatus().then(response => {
    return {
      ...response,
      resources: response.resources.map(MapperApi2_0.mapParticipantChampionshipStatus),
    };
  });
};

export default getParticipantChampionshipsStatus;
